import { createContext, useState, ReactNode } from 'react'
import { MembershipProps } from 'src/hook/useMembership/types'

export type MembershipContextProps = {
  membership: MembershipProps | undefined
  setMembership: (membership: MembershipProps) => void
}

export const MembershipContext = createContext({} as MembershipContextProps)

type MembershipProviderProps = {
  children: ReactNode
}

export const MembershipProvider = ({ children }: MembershipProviderProps) => {
  const [membership, setMembership] = useState<MembershipProps>()

  return (
    <MembershipContext.Provider
      value={{
        membership,
        setMembership
      }}
    >
      {children}
    </MembershipContext.Provider>
  )
}
